var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.status)?_c('i',{staticClass:"material-icons micon text-success"},[_vm._v("lens")]):_c('i',{staticClass:"material-icons micon text-error"},[_vm._v("lens")])
}
var staticRenderFns = []

export { render, staticRenderFns }